import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingLarge } from '../LoadingLarge/index.js';
export const LoadingPage = () => {
    return _jsx(LoadingLarge, {});
};
//# sourceMappingURL=index.js.map